import { useEffect } from "react";

import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";
import styled from "styled-components";

import { PageTopBanner } from "app/components/PageTopBanner/PageTopBanner";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { removeLocalDashboardData } from "app/pages/dashboard/components/NavigationHeader/ProjectDashboardHelper";
import { ConnectedDashboardSideNav } from "app/pages/dashboard/DashboardSideNav";

const DashboardParentContainer = styled.div`
    overflow-y: auto;
    height: 100%;
    overflow-x: hidden;
    flex-grow: 1;
    position: relative;
`;

DashboardParentContainer.displayName = "DashboardParentContainer";

export const DashboardParentPageV2 = () => {
    const { state, params } = useCurrentStateAndParams();
    const { dashboardId } = params;

    useEffect(() => {
        removeLocalDashboardData();
    }, [dashboardId]);

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[state, params]}
        >
            <div
                id={"parent"}
                className="sw-layout-module-inner dashboard-scroll"
            >
                <ConnectedDashboardSideNav />
                <DashboardParentContainer className="DashboardParentContainer u-flex-row u-flex-column">
                    <PageTopBanner />
                    <UIView className="dashboard-container use-sticky-css-rendering fadeIn" />
                </DashboardParentContainer>
            </div>
        </ErrorBoundary>
    );
};
